import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'fgb-facial-recognition-photo-success',
  templateUrl: './facial-recognition-photo-success.component.html',
  styleUrl: './facial-recognition-photo-success.component.scss',
})
export class FacialRecognitionPhotoSuccessComponent implements OnInit, OnDestroy {
  @Input() uploadedImage: FormControl = new FormControl();
  @Input() stepCounter: number = 5;
  @Output() setStep = new EventEmitter();
  @Output() previousStepChange = new EventEmitter();
  imageSrc: string;
  closeBrowser: boolean = false;
  private routeSub: Subscription;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.routeSub = this.route.queryParamMap.subscribe((paramMap) => {
      if (paramMap.get('key')) {
        this.closeBrowser = true;
      } else {
        this.closeBrowser = false;
      }
    });

    this.uploadedImage.valueChanges.subscribe((data) => {
      if (data) {
        this.imageSrc = data;
      }
    });
  }

  ngOnDestroy() {
    this.routeSub?.unsubscribe();
  }
}
